"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePass = changePass;
exports.closeUser = closeUser;
exports.createUser = createUser;
exports.deleteUser = deleteUser;
exports.getUserById = getUserById;
exports.getUserRoleTree = getUserRoleTree;
exports.openUser = openUser;
exports.queryUserPage = queryUserPage;
exports.updateUser = updateUser;
exports.updateUserRole = updateUserRole;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取用户列表
function queryUserPage(query) {
  return (0, _requestAuth.default)({
    url: '/sysUser/page',
    method: 'get',
    params: query
  });
}

// 创建用户
function createUser(data) {
  return (0, _requestAuth.default)({
    url: '/sysUser',
    method: 'post',
    data: data
  });
}

// 更新用户
function updateUser(data) {
  return (0, _requestAuth.default)({
    url: '/sysUser',
    method: 'put',
    data: data
  });
}

// 获取用户详情
function getUserById(id) {
  return (0, _requestAuth.default)({
    url: '/sysUser/' + id,
    method: 'get'
  });
}

// 删除用户信息
function deleteUser(data) {
  return (0, _requestAuth.default)({
    url: '/sysUser',
    method: 'delete',
    data: data
  });
}

// 禁用用户
function closeUser(id) {
  return (0, _requestAuth.default)({
    url: '/sysUser/update',
    method: 'post',
    data: {
      userId: id,
      status: 0
    }
  });
}

// 启用用户
function openUser(id) {
  return (0, _requestAuth.default)({
    url: '/sysUser/update',
    method: 'post',
    data: {
      userId: id,
      status: 1
    }
  });
}

// 获取角色树以及用户和角色的关联关系
function getUserRoleTree(userId) {
  return (0, _requestAuth.default)({
    url: '/sysUserRole/' + userId,
    method: 'get'
  });
}

// 更新用户角色关联关系
function updateUserRole(data) {
  return (0, _requestAuth.default)({
    url: '/sysUserRole',
    method: 'post',
    data: data
  });
}

//修改密码 change
function changePass(data) {
  return (0, _requestAuth.default)({
    url: '/changePassword',
    method: 'post',
    data: data
  });
}